import { Badge } from 'react-bootstrap'
import { Trans, useTranslation } from 'react-i18next'
import FMT from 'utils/fmt'
import useThirdPartyDeliveryStatus from 'utils/useThirdPartyDeliveryStatus'

/**
 * @param restaurant {Restaurant}
 * @param type {string}
 * @param as {'li'|'div'} If this is showing up standalone or as part of a `<ul>`
 * @returns {JSX.Element}
 */
export default function OrderingStatus({ restaurant, type, as = 'div' }) {
	const orderType = FMT.orderType(type)
	const { t } = useTranslation()
	const {isThirdPartyDeliveryDisabled, isDeliveryDisabled} = useThirdPartyDeliveryStatus(type, restaurant)
	const thirdPartyDeliveryClosedMessage = isThirdPartyDeliveryDisabled ? t(' - Third-party delivery is currently unavailable due to a service interruption') : ''
	const isClosed  = restaurant.isPublicOrderingClosedForType(type) || isDeliveryDisabled
	const ClosedText = isDeliveryDisabled ? () => '' : restaurant.ClosedTextFor(type)
	const Tag = as
	return <Tag className="order-type-status">
		<Badge variant={isClosed? 'danger' : (isThirdPartyDeliveryDisabled ? 'warning' : 'success')}>
			<orderType.Icon fixedWidth/>
		</Badge>

		<span>
			{isClosed? //TODO this might have some latent bug - check note at closedTextFor()
				<Trans><b>{{ orderType: orderType.name }}</b> is OFF <ClosedText/></Trans> :
				<Trans><b>{{ orderType: orderType.name }}</b> is ON</Trans>
			}
			{thirdPartyDeliveryClosedMessage}
			{/* TODO it would be better if we could avoid capitalized words for calling out attention (the same applies to the "or change ALL order types at once" at the DisableOrderingModal)... Nut I don't have any better ideas so far, so I'm leaving for the future lol */}
		</span>
	</Tag>
}
